<template>
  <v-card class="pa-2" width="300" data-testid="appointment-checkin-advertisement-box">
    <v-card-title>
      <span class="text-break mb-2">
        {{
          isCurrentUserAdminOrOwner
            ? $t(
                'assetVisit.dialogs.checkinNotificationPanelDialog.messages.enhanceYourFacilitysEfficiencyWith'
              )
            : $t(
                'assetVisit.dialogs.checkinNotificationPanelDialog.messages.optimizeYourWorkflowWith'
              )
        }}
        <a
          target="_blank"
          @click="mixpanelClick('Fake-door Hyperlink')"
          :href="isCurrentUserAdminOrOwner ? linkGateManagement : linkGateManagementOthers">
          {{ $t('global.specialtyTerms.gateManagement') }}
        </a>
      </span>
    </v-card-title>
    <v-card-text class="mt-4">
      <p class="mb-1">
        <v-icon size="small" color="primary" class="mr-2">mdi-check-circle-outline</v-icon>
        <i18n-t keypath="assetVisit.dialogs.checkinNotificationPanelDialog.messages.driversAction">
          <strong>{{ $t('global.specialtyTerms.selfCheckIn') }}</strong>
        </i18n-t>
      </p>
      <p class="mb-1">
        <v-icon size="small" color="primary" class="mr-2">mdi-check-circle-outline</v-icon>
        <strong>
          {{ $t('assetVisit.dialogs.checkinNotificationPanelDialog.messages.realTimeAlerts') }}
        </strong>
        {{ $t('assetVisit.dialogs.checkinNotificationPanelDialog.messages.forAllArrivals') }}
      </p>
      <p class="mb-1">
        <v-icon size="small" color="primary" class="mr-2">mdi-check-circle-outline</v-icon>
        <strong>{{ $t('assetVisit.common.terms.unplannedArrivals', 2) }}</strong>
        {{ $t('assetVisit.dialogs.checkinNotificationPanelDialog.messages.visibility') }}
      </p>
      <p class="mb-1">
        <v-icon size="small" color="primary" class="mr-2">mdi-check-circle-outline</v-icon>
        <span v-if="isCurrentUserAdminOrOwner">
          <strong>
            {{ $t('assetVisit.dialogs.checkinNotificationPanelDialog.messages.insightsReports') }}
          </strong>
          {{ $t('assetVisit.dialogs.checkinNotificationPanelDialog.messages.intoGateActivity') }}
        </span>
        <span v-else>
          <strong>
            {{ $t('assetVisit.dialogs.checkinNotificationPanelDialog.messages.autoUpdate') }}
          </strong>
          {{ $t('global.specialtyTerms.appointments', 2).toLowerCase() }}
        </span>
      </p>
      <p class="mb-1">
        <v-icon size="small" color="primary" class="mr-2">mdi-check-circle-outline</v-icon>
        {{ $t('assetVisit.dialogs.checkinNotificationPanelDialog.messages.inApp') }}
        <strong>
          {{ $t('assetVisit.dialogs.checkinNotificationPanelDialog.messages.2WaySms') }}
        </strong>
      </p>
    </v-card-text>
    <v-card-actions>
      <div class="text-center full-width">
        <p>
          {{
            isCurrentUserAdminOrOwner
              ? $t('assetVisit.dialogs.checkinNotificationPanelDialog.messages.wantToLearnMore')
              : $t(
                  'assetVisit.dialogs.checkinNotificationPanelDialog.messages.believeYourFacilityCouldBenefit'
                )
          }}
        </p>
        <p>
          <v-btn
            v-if="isCurrentUserAdminOrOwner"
            target="_blank"
            class="small bg-secondary"
            @click="mixpanelClick('Fake-door Primary Button')"
            :href="linkContactSales">
            <span class="text-white">
              <v-icon size="small" class="mr-2">mdi-open-in-new</v-icon>
              {{ $t('assetVisit.dialogs.checkinNotificationPanelDialog.buttons.contactSales') }}
            </span>
          </v-btn>
          <v-btn class="bg-secondary" v-else @click="requestCheckInFeature">
            <span class="text-white">
              {{ $t('assetVisit.dialogs.checkinNotificationPanelDialog.messages.yesImInterested') }}
            </span>
          </v-btn>
        </p>
        <p class="pt-2">
          <a v-if="isCurrentUserAdminOrOwner" @click="requestCheckInFeature">
            {{ $t('assetVisit.dialogs.checkinNotificationPanelDialog.links.requestATrial') }}
          </a>
          <a
            :href="mailToContent"
            target="_blank"
            @click="mixpanelClick('Fake-door Share link')"
            v-else>
            <v-icon size="small" class="mr-1" color="secondary">mdi-email-fast-outline</v-icon>
            {{ $t('assetVisit.dialogs.checkinNotificationPanelDialog.links.shareWithMyTeam') }}
          </a>
        </p>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import mixpanelEvents from '@/enums/MixpanelEvents';

export default {
  props: {
    warehouse: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    mixpanelClick(type) {
      this.mixpanel.track(mixpanelEvents.MODULE.SELF_CHECK_IN.CTA_CLICKED, {
        'CTA Type': type,
        ...this.mixpanelBaseData
      });
      this.notify(
        this.$t(
          'assetVisit.dialogs.checkinNotificationPanelDialog.messages.thankYouOurTeamWillContactYouSoon'
        ),
        'success'
      );
    },
    requestCheckInFeature() {
      this.mixpanel.track(mixpanelEvents.MODULE.SELF_CHECK_IN.SELF_CHECK_IN_REQUESTED, {
        'Entry Point': 'Gate Management Panel',
        ...this.mixpanelBaseData
      });
      this.notify(
        this.$t(
          'assetVisit.dialogs.checkinNotificationPanelDialog.messages.thankYouOurTeamWillContactYouSoon'
        ),
        'success'
      );
    }
  },
  computed: {
    userRole() {
      return this.$me?.role;
    },
    mixpanelBaseData() {
      return {
        'Org ID': this.$me.orgId,
        'Org Name': this.$me.orgName,
        'Warehouse ID': this.warehouse.id,
        'Warehouse Name': this.warehouse.name
      };
    },
    isCurrentUserAdminOrOwner() {
      return (
        this.userRole === this.novaCore.UserRole.ADMIN ||
        this.userRole === this.novaCore.UserRole.OWNER
      );
    },
    linkGateManagement() {
      return 'https://lp.opendock.com/gate-management?utm_source=salescollateral&utm_medium=hyperlink&utm_campaign=opendock-gate-management-owner-admin-warehouse-opendock-q2-24&utm_content=hyperlink';
    },
    linkGateManagementOthers() {
      return 'https://lp.opendock.com/gate-management?utm_source=salescollateral&utm_medium=hyperlink&utm_campaign=opendock-gate-management-operator-attendant-warehouse-opendock-q2-24&utm_content=hyperlink';
    },
    linkContactSales() {
      return 'https://lp.opendock.com/gate-management?utm_source=opendockapp&utm_medium=cta&utm_campaign=opendock-gate-management-warehouse-opendock-q2-24&utm_content=landing-page';
    },
    mailToContent() {
      const body =
        `${this.$t('assetVisit.dialogs.checkinNotificationPanelDialog.messages.hi')}` +
        `${this.$t(
          'assetVisit.dialogs.checkinNotificationPanelDialog.messages.iJustFoundOutAboutOpendocksGateManagementToolWhichIThinkCouldReallyBenefitOurFacilityOperations'
        )}` +
        `${this.$t(
          'assetVisit.dialogs.checkinNotificationPanelDialog.messages.itOffersFeaturesLikeSelfCheckInForDriversAutoAppointmentStatusUpdatesRealTimeAlertsOnPlannedAndUnplannedArrivalsAndUpcoming2WaySmsCommunicationWithDrivers'
        )}` +
        '\n' +
        `${this.$t(
          'assetVisit.dialogs.checkinNotificationPanelDialog.messages.forMoreInformationOrToRequestATrialVisitTheGateManagementWebsiteAt'
        )} https://lp.opendock.com/gate-management.`;

      const subject = this.$t(
        'assetVisit.dialogs.checkinNotificationPanelDialog.messages.checkOutOpendocksGateManagement'
      );

      return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    }
  }
};
</script>
